<template>
  <v-dialog v-model="visible" persistent max-width="638">
    <v-card class="v-dialog--custom" v-if="visible">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title my-2">
          {{ browser === 'not supported' ? $t(`${namespace}.notSupportedTitle`) : $t(`${namespace}.outdatedBrowserTitle`) }}
        </span>
      </v-card-title>

      <v-card-text class="px-4 pt-0">
        <div v-if="browser === 'not supported'">
          <p>{{ $t(`${namespace}.notSupportedText`) }}</p>
          <ul class="browser-list">
            <li>
              <a href="https://www.google.com/intl/pt-BR/chrome/" title="Google Chrome">
                <img src="./img/chrome.svg" alt="">
                <span>Google Chrome</span>
              </a>
            </li>

            <li>
              <a href="https://www.mozilla.org/pt-BR/firefox/" title="Mozilla Firefox">
                <img src="./img/firefox.svg" alt="">
                <span>Mozilla Firefox</span>
              </a>
            </li>

            <li>
              <a href="https://www.microsoft.com/pt-br/edge" title="Microsoft Edge">
                <img src="./img/internet-explorer.svg" alt="">
                <span>Microsoft Edge</span>
              </a>
            </li>
          </ul>
        </div>

        <p v-else class="pb-2">{{ $t(`${namespace}.outdatedBrowserText`) }}</p>
      </v-card-text>

      <v-divider />

      <v-card-actions v-if="browser === 'not supported'" class="pa-4">
        <v-spacer />
        <v-btn
          round
          depressed
          color="accent"
          @click.native="close"
        >
          {{ $t('Common.close') }}
        </v-btn>
      </v-card-actions>

      <v-card-actions v-else class="pa-4">
        <v-spacer />

        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          v-html="$t(`${namespace}.proceed`).replace('[BROWSER]', `<span class='text--capitalize'>&nbsp;${browser}</span>`)"
          round
          depressed
          color="accent"
          @click.native="updateBrowser"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BrowserCompatibilityDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    browser: {
      type: String,
      default: null
    },
    version: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      namespace: 'Components.BrowserCompatibilityDialog'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    updateBrowser () {
      if (this.browser === 'chrome') {
        location.href = 'https://www.google.com/intl/pt-BR/chrome/'
      }

      if (this.browser === 'firefox') {
        location.href = 'https://www.mozilla.org/pt-BR/firefox/'
      }

      if (this.browser === 'ie' || this.browser === 'internet explorer') {
        location.href = 'https://www.microsoft.com/pt-br/edge'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.browser-list {
  display: flex;
  list-style-type: none;
  margin: 0 auto;
  padding: 16px 0;
  width: 70%;

  li {
    display: flex;
    flex: 1;
    justify-content: center;
    margin-bottom: 8px;

    a {
      align-items: center;
      color: $gray-8;
      display: flex;
      flex-direction: column;
      font-weight: 600;
      text-decoration: none;
    }

    img {
      margin-bottom: 16px;
      width: 60px;
    }

    span {
      text-align: center;
    }
  }
}
</style>
